import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight, Calendar, MapPin, Clock, Users, Search, Filter } from 'lucide-react';
const fadeIn = {
  initial: {
    opacity: 0,
    y: 20
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true,
    margin: '-100px'
  },
  transition: {
    duration: 0.6
  }
};
export function Events() {
  const events = [{
    id: 1,
    title: 'African Cultural Festival',
    date: 'Aug 15, 2026',
    time: '10:00 AM - 8:00 PM',
    location: 'Central Park, NY',
    audience: 'Families, All Ages',
    type: 'Annual',
    img: 'https://images.unsplash.com/photo-1533222481259-ce20eda1e20b?q=80&w=2940&auto=format&fit=crop',
    desc: 'Our flagship yearly event celebrating African culture, heritage, music, and food.'
  }, {
    id: 2,
    title: 'Entrepreneurship Seminar',
    date: 'Jul 21, 2026',
    time: '2:00 PM - 5:00 PM',
    location: 'Poch Center, NY',
    audience: 'Professionals',
    type: 'Monthly',
    img: 'https://images.unsplash.com/photo-1515162816999-a0c47dc192f7?q=80&w=2940&auto=format&fit=crop',
    desc: 'Learn from successful business leaders and network with fellow entrepreneurs.'
  }, {
    id: 3,
    title: 'Youth Innovation Workshop',
    date: 'Every Saturday',
    time: '10:00 AM - 1:00 PM',
    location: 'Virtual / Poch Center',
    audience: 'Youth (12-18)',
    type: 'Weekly',
    img: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?q=80&w=2922&auto=format&fit=crop',
    desc: 'Weekly hands-on coding and robotics sessions for the next generation of innovators.'
  }, {
    id: 4,
    title: 'Health Awareness Session',
    date: 'Aug 5, 2026',
    time: '6:00 PM - 8:00 PM',
    location: 'Community Hall',
    audience: 'Adults',
    type: 'Monthly',
    img: 'https://images.unsplash.com/photo-1584515933487-779824d29309?q=80&w=2940&auto=format&fit=crop',
    desc: 'Expert-led session focusing on preventative care and behavioral wellness.'
  }];
  return <div className="pt-0 bg-warmwhite" data-id="element-716" data-mp="zd3annx1zztn">
      {/* Hero Section */}
      <section className="relative pt-32 pb-16 bg-navy overflow-hidden" data-id="element-717" data-mp="1453550ucu0iu">
        <div className="absolute inset-0 z-0" data-id="element-718" data-mp="194g1cc748jy3">
          <img src="https://images.unsplash.com/photo-1511632765486-a01980e01a18?q=80&w=2940&auto=format&fit=crop" alt="Events" className="w-full h-full object-cover opacity-30" data-id="element-719" data-mp="1934prq7fi7wf" />
          <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/80 to-transparent" data-id="element-720" data-mp="ghv1enckqzix" />
        </div>
        <div className="container mx-auto px-6 md:px-12 relative z-10 text-center max-w-4xl" data-id="element-721" data-mp="lh7xzzt8zkyp">
          <h1 className="text-5xl md:text-6xl font-serif font-bold text-white mb-6" data-id="element-722" data-mp="qblmrjdemtue">
            Poch Global Events
          </h1>
          <p className="text-xl text-white/80 leading-relaxed mb-8" data-id="element-723" data-mp="21slnn3dtih01">
            From annual celebrations to weekly workshops, join our community
            events designed to educate, inspire, and connect.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-724" data-mp="3hd45jbcs38kv">
            <button className="w-full sm:w-auto px-8 py-4 bg-gold hover:bg-gold-light text-white rounded-full font-bold transition-all shadow-lg" data-id="element-725" data-mp="3ckuh5zrbagkp">
              Filter Events
            </button>
            <button className="w-full sm:w-auto px-8 py-4 border-2 border-white text-white hover:bg-white hover:text-navy rounded-full font-bold transition-all" data-id="element-726" data-mp="33l7fdcuo78r4">
              Create Event Alert
            </button>
          </div>
        </div>
      </section>

      {/* Search & Filters */}
      <section className="py-8 bg-white border-b border-softgray" data-id="element-727" data-mp="2onneah0w9xq8">
        <div className="container mx-auto px-6 md:px-12" data-id="element-728" data-mp="2opi2q5bdk7z2">
          <div className="flex flex-col gap-4" data-id="element-729" data-mp="ru2ejnol18gb">
            {/* Search Bar */}
            <div className="relative w-full" data-id="element-730" data-mp="mviszodwhyoh">
              <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-mediumgray w-5 h-5" data-id="element-731" data-mp="mwtutinscwcy" />
              <input type="text" placeholder="Search events..." className="w-full pl-12 pr-4 py-3 bg-warmwhite border border-softgray rounded-xl focus:outline-none focus:border-navy focus:ring-1 focus:ring-navy" data-id="element-732" data-mp="uxhyrnnvy6a4" />
            </div>
            
            {/* Filter Dropdowns */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-733" data-mp="c6ig146zhspa">
              <div className="relative" data-id="element-734" data-mp="gwytgoat1ebn">
                <select className="w-full pl-10 pr-4 py-3 bg-warmwhite border border-softgray rounded-xl focus:outline-none focus:border-navy text-mediumgray appearance-none" data-id="element-735" data-mp="gy0glr53hr9q">
                  <option value="" data-id="element-736" data-mp="76mb92qgpx8o">Event Type (All)</option>
                  <option value="workshop" data-id="element-737" data-mp="751j1jrmeqdz">Workshop</option>
                  <option value="festival" data-id="element-738" data-mp="3pdtoxip9vwfp">Festival</option>
                  <option value="seminar" data-id="element-739" data-mp="3tecfl9ffiwgb">Seminar</option>
                  <option value="training" data-id="element-740" data-mp="3tdudvx9zzq10">Training</option>
                  <option value="cultural" data-id="element-741" data-mp="3apjv9scmc2bz">Cultural Event</option>
                </select>
                <Filter className="absolute left-4 top-1/2 -translate-y-1/2 text-mediumgray w-4 h-4 pointer-events-none" data-id="element-742" data-mp="35r8l1gievpt8" />
              </div>
              <div className="relative" data-id="element-743" data-mp="3jsb9fzwvpc7b">
                <select className="w-full pl-10 pr-4 py-3 bg-warmwhite border border-softgray rounded-xl focus:outline-none focus:border-navy text-mediumgray appearance-none" data-id="element-744" data-mp="3ern7ij743ayb">
                  <option value="" data-id="element-745" data-mp="3tmtep9hy1ft8">Month / Date Range</option>
                  <option value="this-month" data-id="element-746" data-mp="3oorycwbwjulg">This Month</option>
                  <option value="next-month" data-id="element-747" data-mp="6btzyturd9te">Next Month</option>
                  <option value="later" data-id="element-748" data-mp="6b255l8zjg46">Later This Year</option>
                </select>
                <Calendar className="absolute left-4 top-1/2 -translate-y-1/2 text-mediumgray w-4 h-4 pointer-events-none" data-id="element-749" data-mp="2as32jobd9ul" />
              </div>
              <div className="relative" data-id="element-750" data-mp="bay8di9uz3io">
                <select className="w-full pl-10 pr-4 py-3 bg-warmwhite border border-softgray rounded-xl focus:outline-none focus:border-navy text-mediumgray appearance-none" data-id="element-751" data-mp="bc9ehoqs0ncy">
                  <option value="" data-id="element-752" data-mp="393zxyjliq03a">Location (All)</option>
                  <option value="ny" data-id="element-753" data-mp="392f3etz7eh5f">New York</option>
                  <option value="virtual" data-id="element-754" data-mp="3e2jokxb2401z">Virtual</option>
                  <option value="other" data-id="element-755" data-mp="3iub4mdwl6ndv">Other Locations</option>
                </select>
                <MapPin className="absolute left-4 top-1/2 -translate-y-1/2 text-mediumgray w-4 h-4 pointer-events-none" data-id="element-756" data-mp="3iw5s9zz8stln" />
              </div>
              <div className="relative" data-id="element-757" data-mp="3srpkabaor854">
                <select className="w-full pl-10 pr-4 py-3 bg-warmwhite border border-softgray rounded-xl focus:outline-none focus:border-navy text-mediumgray appearance-none" data-id="element-758" data-mp="3sqo09hbozbb9">
                  <option value="" data-id="element-759" data-mp="5mhwctwc9pbb">Audience (All)</option>
                  <option value="youth" data-id="element-760" data-mp="22gb9rhcllnxh">Youth</option>
                  <option value="adults" data-id="element-761" data-mp="22hmf3lloz3qp">Adults</option>
                  <option value="families" data-id="element-762" data-mp="27emitpv2juen">Families</option>
                  <option value="professionals" data-id="element-763" data-mp="27h8qrqlvgbxe">Professionals</option>
                </select>
                <Users className="absolute left-4 top-1/2 -translate-y-1/2 text-mediumgray w-4 h-4 pointer-events-none" data-id="element-764" data-mp="1zxpz6vykbad7" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Upcoming Events Grid */}
      <section className="py-12 lg:py-16" data-id="element-765" data-mp="1l78zpi5hmuiy">
        <div className="container mx-auto px-6 md:px-12" data-id="element-766" data-mp="1l8brdsamx0zx">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8" data-id="element-767" data-mp="2iv0wib0mvtq0">
            {events.map(event => <motion.div key={event.id} variants={fadeIn} initial="initial" whileInView="whileInView" className="bg-white rounded-3xl overflow-hidden shadow-sm border border-softgray hover:shadow-premium transition-all duration-300 group flex flex-col" data-id="element-768" data-mp="2dwpnu3m2rp9d">
                <div className="h-56 overflow-hidden relative" data-id="element-769" data-mp="tfkstb5hb07i">
                  <img src={event.img} alt={event.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-770" data-mp="te9nv80armet" />
                  <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-bold text-navy uppercase tracking-wider" data-id="element-771" data-mp="2jjmoknpieys5">
                    {event.type}
                  </div>
                </div>
                <div className="p-6 flex flex-col flex-grow" data-id="element-772" data-mp="3c9d5t5mfugsh">
                  <h3 className="text-xl font-bold text-navy mb-4" data-id="element-773" data-mp="3g9nkr7s7khjh">
                    {event.title}
                  </h3>
                  <div className="space-y-3 mb-6 flex-grow" data-id="element-774" data-mp="32ja8it8aagoc">
                    <div className="flex items-center gap-3 text-sm text-mediumgray" data-id="element-775" data-mp="37hlmng5m3dcd">
                      <Calendar className="w-4 h-4 text-gold" data-id="element-776" data-mp="37f8u69289kl2" /> {event.date}
                    </div>
                    <div className="flex items-center gap-3 text-sm text-mediumgray" data-id="element-777" data-mp="3v5bjwiio6egi">
                      <Clock className="w-4 h-4 text-gold" data-id="element-778" data-mp="3ul9bkr3p25a" /> {event.time}
                    </div>
                    <div className="flex items-center gap-3 text-sm text-mediumgray" data-id="element-779" data-mp="d57koxjweji4">
                      <MapPin className="w-4 h-4 text-gold" data-id="element-780" data-mp="957539l2c29h" /> {event.location}
                    </div>
                    <div className="flex items-center gap-3 text-sm text-mediumgray" data-id="element-781" data-mp="mwby3stxdwau">
                      <Users className="w-4 h-4 text-gold" data-id="element-782" data-mp="hyk9p8shosbe" /> {event.audience}
                    </div>
                  </div>
                  <p className="text-mediumgray text-sm mb-6 line-clamp-2" data-id="element-783" data-mp="3qfwx4nml72hk">
                    {event.desc}
                  </p>
                  <div className="flex gap-3 mt-auto" data-id="element-784" data-mp="475cny1qyqlc">
                    <button className="flex-1 py-3 bg-navy hover:bg-navy-light text-white rounded-xl font-semibold transition-colors text-sm" data-id="element-785" data-mp="47x6p4fp4g9i">
                      Register
                    </button>
                    <button className="flex-1 py-3 bg-warmwhite hover:bg-navy hover:text-white text-navy border border-navy rounded-xl font-semibold transition-colors text-sm" data-id="element-786" data-mp="1fnvpi00oegnx">
                      Learn More
                    </button>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Event Categories */}
      <section className="py-12 lg:py-16 bg-warmwhite border-t border-softgray" data-id="element-787" data-mp="13u7pnjmffc4s">
        <div className="container mx-auto px-6 md:px-12" data-id="element-788" data-mp="ywobejpqazcu">
          <div className="text-center max-w-3xl mx-auto mb-12 lg:mb-16" data-id="element-789" data-mp="uw5jkpnu5tan">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy mb-4" data-id="element-790" data-mp="ut9n75rmzcob">
              Event Categories
            </h2>
            <p className="text-mediumgray text-base md:text-lg" data-id="element-791" data-mp="kwn1kerhkhl8">
              Explore the different types of gatherings we host throughout the year.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8" data-id="element-792" data-mp="2fb7g09p7rgw6">
            {[{
            title: 'Annual Celebrations',
            desc: 'Our flagship yearly events celebrating African culture, heritage, and community.',
            featured: 'African Cultural Festival',
            linkText: 'View All Annual Events'
          }, {
            title: 'Monthly Programs',
            desc: 'Regular community gatherings throughout the year focusing on specific themes.',
            featured: 'Health Awareness Session',
            linkText: 'View All Monthly Events'
          }, {
            title: 'Weekly Workshops',
            desc: 'Ongoing training and educational programs held throughout the week.',
            featured: 'Youth Innovation Workshop',
            linkText: 'View Weekly Schedule'
          }, {
            title: 'Special Showcases',
            desc: 'Unique events featuring performances, exhibitions, and cultural showcases.',
            featured: 'NYC African Museum Tour',
            linkText: 'View Special Events'
          }].map((cat, i) => <motion.div key={i} variants={fadeIn} initial="initial" whileInView="whileInView" className="bg-white p-8 rounded-3xl shadow-sm border border-softgray hover:border-gold/30 transition-colors" data-id="element-793" data-mp="2zjgy9ow317rt" data-mpi={i}>
                <h3 className="text-2xl font-bold text-navy mb-3" data-id="element-794" data-mp="34l68517kjfeb">{cat.title}</h3>
                <p className="text-mediumgray mb-6" data-id="element-795" data-mp="2gvlnmdvroa2x">{cat.desc}</p>
                <div className="bg-warmwhite p-4 rounded-xl mb-6 border border-softgray" data-id="element-796" data-mp="2bw92bxkjnb2g">
                  <span className="text-xs font-bold text-gold uppercase tracking-wider block mb-1" data-id="element-797" data-mp="2qkdgco8niyew">Featured</span>
                  <span className="font-medium text-navy" data-id="element-798" data-mp="2ltn72zx3ubex">{cat.featured}</span>
                </div>
                <button className="text-navy font-bold flex items-center gap-2 hover:text-gold transition-colors" data-id="element-799" data-mp="1y3j48urqqfoz">
                  {cat.linkText} <ArrowRight className="w-4 h-4" data-id="element-800" data-mp="1t4q0vv66452j" />
                </button>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Featured Event Detail */}
      <section className="py-12 lg:py-16 bg-white border-t border-softgray" data-id="element-801" data-mp="dfi2pmbdwg5f">
        <div className="container mx-auto px-6 md:px-12" data-id="element-802" data-mp="3uvgi1mwufhp1">
          <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-start" data-id="element-803" data-mp="3o3yj18hms5y">
            <motion.div variants={fadeIn} initial="initial" whileInView="whileInView" className="lg:w-1/2 lg:sticky lg:top-32 w-full" data-id="element-804" data-mp="3m17cdvlmszn">
              <div className="rounded-[2rem] overflow-hidden shadow-2xl border border-softgray relative" data-id="element-805" data-mp="waf831e2o3ew">
                <img src="https://images.unsplash.com/photo-1540575467063-178a50c2df87?q=80&w=2940&auto=format&fit=crop" alt="Featured Event" className="w-full h-[300px] md:h-[400px] lg:h-[500px] object-cover" data-id="element-806" data-mp="melowz5ulbo5" />
                <div className="absolute top-4 left-4 lg:top-6 lg:left-6 bg-white/90 backdrop-blur-md px-3 py-1.5 lg:px-4 lg:py-2 rounded-full font-bold text-navy text-xs lg:text-sm uppercase tracking-wider shadow-lg" data-id="element-807" data-mp="372q81j8i38he">
                  Event Spotlight
                </div>
              </div>
            </motion.div>

            <motion.div variants={fadeIn} initial="initial" whileInView="whileInView" className="lg:w-1/2 w-full" data-id="element-808" data-mp="38n2zqb05c7av">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-navy mb-6" data-id="element-809" data-mp="a332rzhybpl3">
                Global Leadership Summit 2026
              </h2>
              
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 lg:gap-6 mb-8 p-5 lg:p-6 bg-warmwhite rounded-2xl border border-softgray" data-id="element-810" data-mp="5g926vztth2">
                <div data-id="element-811" data-mp="2kx8otyze0st9">
                  <div className="text-sm font-bold text-mediumgray uppercase tracking-wider mb-1" data-id="element-812" data-mp="2kyjp3otmjifm">Date & Time</div>
                  <div className="font-medium text-navy flex items-center gap-2" data-id="element-813" data-mp="2gv3roq9qde1v"><Calendar className="w-4 h-4 text-gold" data-id="element-814" data-mp="wee7r0lhvv4d" /> Oct 10-12, 2026</div>
                </div>
                <div data-id="element-815" data-mp="10ey4w462iyqi">
                  <div className="text-sm font-bold text-mediumgray uppercase tracking-wider mb-1" data-id="element-816" data-mp="10ghh9jolspn0">Location</div>
                  <div className="font-medium text-navy flex items-center gap-2" data-id="element-817" data-mp="15czn6mvo6u0x"><MapPin className="w-4 h-4 text-gold" data-id="element-818" data-mp="1a5st3e2vk8el" /> Javits Center, NY</div>
                </div>
                <div data-id="element-819" data-mp="1f55cfoujexcf">
                  <div className="text-sm font-bold text-mediumgray uppercase tracking-wider mb-1" data-id="element-820" data-mp="1f3kj22jylkg5">Audience</div>
                  <div className="font-medium text-navy flex items-center gap-2" data-id="element-821" data-mp="1k1vughpwk30h"><Users className="w-4 h-4 text-gold" data-id="element-822" data-mp="1o4sf0dz06972" /> Professionals</div>
                </div>
                <div data-id="element-823" data-mp="1t4deqqlzylku">
                  <div className="text-sm font-bold text-mediumgray uppercase tracking-wider mb-1" data-id="element-824" data-mp="1t2tz92860ek4">Price</div>
                  <div className="font-medium text-navy flex items-center gap-2" data-id="element-825" data-mp="3pxygtqls7mxx"><span className="text-gold font-bold" data-id="element-826" data-mp="3uuyog5ya4xr5">$</span> From $199</div>
                </div>
              </div>

              <div className="space-y-6 text-mediumgray leading-relaxed mb-10" data-id="element-827" data-mp="121t04w3xneie">
                <p data-id="element-828" data-mp="x2oswb0kjqup">
                  Join us for our biggest event of the year. The Global Leadership Summit brings together innovators, entrepreneurs, and cultural leaders from across the diaspora for three days of intensive learning, networking, and inspiration.
                </p>
                <h4 className="font-bold text-navy text-lg mt-8 mb-4" data-id="element-829" data-mp="1kzm13suzxed5">What to Expect:</h4>
                <ul className="space-y-3" data-id="element-830" data-mp="1g112fxve72qt">
                  <li className="flex items-start gap-3" data-id="element-831" data-mp="1fzzrruiagi9m">
                    <div className="w-6 h-6 rounded-full bg-gold/20 text-gold flex items-center justify-center shrink-0 mt-0.5" data-id="element-832" data-mp="1trxrxfu0v3tn">✓</div>
                    <span data-id="element-833" data-mp="1prvp33cjw4cs">Keynote speeches from industry leaders and successful entrepreneurs.</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-834" data-mp="23qmzaeoal5vn">
                    <div className="w-6 h-6 rounded-full bg-gold/20 text-gold flex items-center justify-center shrink-0 mt-0.5" data-id="element-835" data-mp="1ys208iks0s8s">✓</div>
                    <span data-id="element-836" data-mp="2idu2tzbg71ki">Interactive workshops focused on scaling businesses and community impact.</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-837" data-mp="28ewi77h57s6s">
                    <div className="w-6 h-6 rounded-full bg-gold/20 text-gold flex items-center justify-center shrink-0 mt-0.5" data-id="element-838" data-mp="28ecz3nfraxr6">✓</div>
                    <span data-id="element-839" data-mp="2dfslpjxl1cbo">Exclusive networking sessions and a cultural gala dinner.</span>
                  </li>
                </ul>
              </div>

              <div className="flex flex-col sm:flex-row gap-4 pt-8 border-t border-softgray" data-id="element-840" data-mp="24ecibw56qagy">
                <button className="px-8 py-4 bg-navy hover:bg-navy-light text-white rounded-full font-bold transition-all shadow-lg flex-1" data-id="element-841" data-mp="1ppg2ve0stv6b">
                  Register Now
                </button>
                <button className="px-8 py-4 bg-warmwhite border border-softgray text-navy hover:border-navy rounded-full font-bold transition-all flex-1" data-id="element-842" data-mp="1goroujbenutf">
                  Add to Calendar
                </button>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Past Events Gallery */}
      <section className="py-12 lg:py-16 bg-warmwhite border-t border-softgray" data-id="element-843" data-mp="1w3nbj1go0uv6">
        <div className="container mx-auto px-6 md:px-12" data-id="element-844" data-mp="1r528yvdxxz3k">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-8 lg:mb-12 gap-4" data-id="element-845" data-mp="1m823all06ycz">
            <div data-id="element-846" data-mp="1i70ekyopq4p9">
              <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy mb-2 lg:mb-4" data-id="element-847" data-mp="1i7i7blc620sf">
                Event Highlights
              </h2>
              <p className="text-mediumgray text-base md:text-lg" data-id="element-848" data-mp="18g5ht0dubmpk">
                A look back at some of our most memorable moments.
              </p>
            </div>
            <button className="hidden md:flex items-center gap-2 text-gold font-bold hover:text-gold-light transition-colors" data-id="element-849" data-mp="13ivq1e2zayyk">
              View Event Gallery <ArrowRight className="w-4 h-4" data-id="element-850" data-mp="ufupru0so22t" />
            </button>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4" data-id="element-851" data-mp="363zt8202qxpj">
            <div className="sm:col-span-2 sm:row-span-2 rounded-3xl overflow-hidden relative group h-[250px] sm:h-[400px]" data-id="element-852" data-mp="3662fqc20q8pi">
              <img src="https://images.unsplash.com/photo-1511578314322-379afb476865?q=80&w=2938&auto=format&fit=crop" alt="Gala" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-853" data-mp="3f3wcfo3p34d7" />
              <div className="absolute inset-0 bg-gradient-to-t from-navy/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-6" data-id="element-854" data-mp="2mgs5veoyehzb">
                <span className="text-white font-bold text-lg" data-id="element-855" data-mp="2wcvd2yynx6t4">Annual Gala 2025</span>
              </div>
            </div>
            <div className="rounded-3xl overflow-hidden relative group h-[192px]" data-id="element-856" data-mp="3167tilt6u7as">
              <img src="https://images.unsplash.com/photo-1544531586-fde5298cdd40?q=80&w=2940&auto=format&fit=crop" alt="Workshop" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-857" data-mp="23og3wt27pipp" />
            </div>
            <div className="rounded-3xl overflow-hidden relative group h-[192px]" data-id="element-858" data-mp="1lkzjwyinuzj3">
              <img src="https://images.unsplash.com/photo-1528605248644-14dd04022da1?q=80&w=2940&auto=format&fit=crop" alt="Festival" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-859" data-mp="1ln2i45tyvyyw" />
            </div>
            <div className="col-span-2 rounded-3xl overflow-hidden relative group h-[192px]" data-id="element-860" data-mp="xw6lmvekgflb">
              <img src="https://images.unsplash.com/photo-1552664730-d307ca884978?q=80&w=2940&auto=format&fit=crop" alt="Seminar" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-861" data-mp="12tovqp4bl0uw" />
            </div>
          </div>
          <button className="md:hidden mt-8 w-full py-4 bg-white border border-softgray text-navy rounded-full font-bold flex items-center justify-center gap-2" data-id="element-862" data-mp="1cm4dpmfm9pfs">
            View Event Gallery <ArrowRight className="w-4 h-4" data-id="element-863" data-mp="k25v2oxrpyw1" />
          </button>
        </div>
      </section>

      {/* Event Alert Signup */}
      <section className="py-12 lg:py-16 bg-navy text-white relative overflow-hidden" data-id="element-864" data-mp="2tcoqq2ewuhwa">
        <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')]" data-id="element-865" data-mp="2takg71miakn1" />
        <div className="container mx-auto px-6 max-w-3xl relative z-10" data-id="element-866" data-mp="2jer1pcp88h2m">
          <div className="text-center mb-12" data-id="element-867" data-mp="2jgv57tj7re2d">
            <h2 className="text-4xl text-white font-serif font-bold mb-4" data-id="element-868" data-mp="2efo0628ggsze">Don't Miss Out</h2>
            <p className="text-white/70 text-lg" data-id="element-869" data-mp="29ofmgu03elgf">
              Sign up to receive notifications about new events, workshops, and
              festivals.
            </p>
          </div>
          <form className="bg-white/5 backdrop-blur-md border border-white/10 p-8 md:p-10 rounded-3xl" data-id="element-870" data-mp="20o9a5bg4rriu">
            <div className="mb-6" data-id="element-871" data-mp="1vpfwnj0ug0io">
              <label className="block text-sm font-bold text-white/80 mb-2" data-id="element-872" data-mp="1voenjk3e1o3l">Email Address</label>
              <input type="email" placeholder="hello@example.com" className="w-full px-6 py-4 rounded-xl bg-white/10 border border-white/20 text-white placeholder:text-white/40 focus:outline-none focus:border-gold transition-colors" data-id="element-873" data-mp="1qqd4gz5ypos4" />
            </div>
            
            <div className="mb-8" data-id="element-874" data-mp="183m06faoi228">
              <label className="block text-sm font-bold text-white/80 mb-4" data-id="element-875" data-mp="1c2l5w248i2uq">I'm interested in (select all that apply):</label>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-876" data-mp="1zu0c45z4t4b9">
                {['Cultural Festivals', 'Business Seminars', 'Youth Workshops', 'Health Awareness', 'Fundraising Galas', 'Virtual Events'].map(interest => <label key={interest} className="flex items-center gap-3 cursor-pointer group" data-id="element-877" data-mp="1qyatu5szcq23">
                    <div className="w-5 h-5 rounded border border-white/30 flex items-center justify-center group-hover:border-gold transition-colors" data-id="element-878" data-mp="1uzw19bmqwc4w">
                      <input type="checkbox" className="opacity-0 absolute" data-id="element-879" data-mp="2nijn4t9kfv71" />
                      <div className="w-3 h-3 rounded-sm bg-gold opacity-0 group-hover:opacity-50 transition-opacity" data-id="element-880" data-mp="c3133ycakduu" />
                    </div>
                    <span className="text-white/80 group-hover:text-white transition-colors" data-id="element-881" data-mp="73oizlct1kvy">{interest}</span>
                  </label>)}
              </div>
            </div>

            <div className="mb-8" data-id="element-882" data-mp="gvc3t3euw3og">
              <label className="block text-sm font-bold text-white/80 mb-2" data-id="element-883" data-mp="gwdidhv2z8ax">Notification Frequency</label>
              <select className="w-full px-6 py-4 rounded-xl bg-white/10 border border-white/20 text-white focus:outline-none focus:border-gold transition-colors appearance-none" data-id="element-884" data-mp="3pbnp539x11p1">
                <option value="weekly" className="text-charcoal" data-id="element-885" data-mp="30jifocabt9y">Weekly Digest</option>
                <option value="monthly" className="text-charcoal" data-id="element-886" data-mp="3u7clyyujw4hn">Monthly Newsletter</option>
                <option value="immediate" className="text-charcoal" data-id="element-887" data-mp="1eg850elmmqa8">As soon as events are announced</option>
              </select>
            </div>

            <button type="submit" className="w-full py-4 bg-gold hover:bg-gold-light text-white font-bold rounded-xl transition-all shadow-lg" data-id="element-888" data-mp="3f78nhgtt68nn">
              Subscribe to Alerts
            </button>
          </form>
        </div>
      </section>
    </div>;
}